import './Footer.css'
import logo from '../img/logo.png'
import { Link, useNavigate } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa6";

function Footer() {
    return(
        <footer className="footer-container">
            <div className="footer">
    <div className="footer-section">
        <div className='logo-title'>
           <div className='footer-logo'>        <a href="/"><img src={logo} alt='logo'></img></a></div> 
            <div className='footer-logo-title'>CREORA</div>
        </div>
        <div className='footer-sub-content'>Creative Devs is a next-gen tech studio specializing in AR, VR, and MR</div>
        </div>
        <div className="footer-section">
        <h3 className='footer-service'>Services</h3>
        <ul>
          {/* <li><Link to="/about">AR/VR Product Demos</Link></li>
          <li><Link to="/policy">MR Training Simulations</Link></li>
          <li><Link to="/refund">Virtual Events</Link></li>
          <li><Link to="/shipping">AR for Marketing</Link></li>
          <li><Link to="/toc">UI/UX for Immersive Apps</Link></li> */}
                   <li> AR/VR Product Demos</li>
          <li>MR Training Simulations</li>
          <li>Virtual Events</li>
          <li>AR for Marketing</li>
          <li> UI/UX for Immersive Apps</li>
          
        </ul>
      </div>
      <div className="footer-section">
      <h3 className='footer-service'>Get in touch</h3>
<div className='creaora-email'>creoradevelopers@gmail.com</div>
<div className='creaora-email'>+91-7010353624</div>
<div className='footer-socials'>
<div className='social-icons'>


        <a href="https://www.instagram.com/creora_developers/
" target="_blank" rel="noopener noreferrer">
          <FaInstagram size={24} />
        </a>
  
    
        <a href="https://www.facebook.com/profile.php?id=61577547987745
" target="_blank" rel="noopener noreferrer">
          <FaFacebookF size={24} />
        </a>
   

   
        <a href="https://www.linkedin.com/company/creora-developers/about/
" target="_blank" rel="noopener noreferrer">
          <FaLinkedinIn size={24} />
        </a>

    </div>
</div>
      </div>
      </div>
      <div className='footer-line'></div>
      <div className="footer-end-content">
  <div className="footer-end-links">
    <a href="/privacy">Privacy Policy</a>
    <a href="/terms">Terms & Conditions</a>
  </div>
  <div>© 2025 Creora Developers. All rights reserved.</div>
</div>

        </footer>
    )
}
export default Footer;
